import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface StoreState {
  name: string;
  logoFile: string | null;
  description: string;
  category: string;
  tags: string[];
  location: string;
  storeTemplate: string;
  storeId: string;
}

const initialState: StoreState = {
  name: '',
  logoFile: null,
  description: '',
  category: '',
  tags: [],
  location: '',
  storeTemplate: '',
  storeId: '',
};

const createStoreSlice = createSlice({
  name: "CreateStore",
  initialState,
  reducers: {
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setLogoFile(state, action: PayloadAction<string | null>) {
      state.logoFile = action.payload;
    },
    setDescription(state, action: PayloadAction<string>) {
      state.description = action.payload;
    },
    setCategory(state, action: PayloadAction<string>) {
      state.category = action.payload;
    },
    setTags(state, action: PayloadAction<string[]>) {
      state.tags = action.payload;
    },
    setLocation(state, action: PayloadAction<string>) {
      state.location = action.payload;
    },
    setStoreTemplate(state, action: PayloadAction<string>) {
      state.storeTemplate = action.payload;
    },
    setStoreId(state, action: PayloadAction<string>) {
      state.storeId = action.payload;
    },
    resetStore() {
      return initialState;
    }
  },
});

export const {
  setName,
  setLogoFile,
  setDescription,
  setCategory,
  setTags,
  setLocation,
  setStoreTemplate,
  setStoreId,
  resetStore,
} = createStoreSlice.actions;

export default createStoreSlice.reducer;